import { pmFetchJson } from "./pmFetch";

export type Facility = any;

// The server returns one row per facility; distinct facilities may share a
// name, so rows are never merged here. Only rows without a usable name drop.
const named = (items: any[]): any[] =>
  items.filter((item) => item && typeof item.name === "string" && item.name.trim() !== "");

export async function findFacility(args: {
  q: string;
  state: string;
  email: boolean;
}): Promise<Facility[]> {
  const res = await pmFetchJson<any>("/find-facility", {
    method: "GET",
    params: { q: args.q, state: args.state, email: args.email ? "true" : "false" },
  });

  const list = Array.isArray(res) ? res : [];
  return named(list);
}

